/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
import React from 'react';

const SearchEmptyScreen = ({emptyScreenMessage, height}) => {
    return (
        <div className={`${height === undefined ? 'h-customh2' : height} w-full flex justify-center items-center`} id="search-result">
            <div>
                <p className="text-f2 font-medium text-[#000000] pt-6 text-center">
                    {emptyScreenMessage}{emptyScreenMessage === "It seems there's nothing to display here."}</p>
            </div>
        </div>
    );
}

export default SearchEmptyScreen;
